import axios from "@/axios/axios";
import publicFn from "@/publicFn/baseFn";
import id from "element-ui/src/locale/lang/id";

//注册用户
function ApplyInsert(
  ApplyId,
  ApplyName,
  ApplyTel,
  ApplyPerson,
  ApplyProvinceId,
  ApplyProvince,
  ApplyCityId,
  ApplyCity,
  ApplyAddress,
  ListShop,
  ApplyVersion,
  ApplySource,
  ApplyTerm
) {
  const formatterListShop = ListShop.map((item) => ({
    ApplyAddress: item.ApplyAddress,
    ApplyCity: item.ApplyCity,
    ApplyCityId: item.ApplyCityId,
    ApplyExpertTel: item.ApplyExpertTel,
    ApplyId: item.ApplyId,
    ApplyName: item.ApplyName,
    ApplyPerson: item.ApplyPerson,
    ApplyProvince: item.ApplyProvince,
    ApplyProvinceId: item.ApplyProvinceId,
    ApplyRegion: item.ApplyRegion,
    ApplyTel: item.ApplyTel,
  }));
  return axios.post(publicFn.getUrl("Apply_Insert"), {
    token: {
      sToken: "60666C4259CF9C06E22CCAB86A74F3CB",
      TimeSpan: "1602473240",
    },
    o: {
      ApplyId,
      ApplyName,
      ApplyTel,
      ApplyPerson,
      ApplyProvinceId,
      ApplyProvince,
      ApplyCityId,
      ApplyCity,
      ApplyAddress,
      ListShop: formatterListShop,
      ApplyVersion,
      ApplySource,
      ApplyTerm,
    },
  });
}

function AreaGetListLevel() {
  return axios.post(publicFn.getUrl("Area_GetListLevel"), {
    token: {
      sToken: "532618542085hvNRUjZTfkyFRrQGb0oN0g6996262EB1AAC747",
      TimeSpan: "532618542085",
    },
    AreaId: "",
  });
}
//商品详情
function PriceSortList(productId, shopId) {
  return axios.post(publicFn.getUrl("priceSortList"), {
    SearchCondition: {
      ProductId: productId,
      ShopId: shopId,
    },
    ReturnInfo: {
      Product: {
        Brand: 1,
        Sort: 1,
        ListProperty: 1,
        ListUploadFile: 1,
        ProductSeries: 1,
      },
      ShopProduct: 1, //增加这行
    },
    token: {
      sToken: "E0B1486293C779EEE7CD24AF277703D7",
      TimeSpan: "1574670974",
    },
  });
}

//上传图片
function UploadFileUpload(
  FileBase64,
  UFReId,
  UFReObject,
  ExtensionName,
  UFType,
  UFSaveType
) {
  return axios.post(publicFn.getUrl("UploadFile_Upload"), {
    token: {
      sToken: "8BED23DE028E0E9966B8CE9E8F77DB89",
      TimeSpan: "1535942069232",
    },
    o: {
      FileBase64,
      UFReId,
      UFReObject,
      ExtensionName,
      UFType,
      UFSaveType,
    },
  });
}
//删除图片
function UploadFileDeleteById(Id) {
  return axios.post(publicFn.getUrl("UploadFile_DeleteById"), {
    token: {
      sToken: "301F39D31879DAB4F4416D31B4801C27",
      TimeSpan: "1630915754",
    },
    Id,
  });
}

//更新申请
function ApplyUpdate(
  ApplyId,
  ApplyName,
  ApplyTel,
  ApplyPerson,
  ApplyProvinceId,
  ApplyProvince,
  ApplyCityId,
  ApplyCity,
  ApplyAddress,
  ListShop,
  ApplyVersion,
  ApplySource,
  ApplyTerm
) {
  const formatterListShop = ListShop.map((item) => ({
    ApplyAddress: item.ApplyAddress,
    ApplyCity: item.ApplyCity,
    ApplyCityId: item.ApplyCityId,
    ApplyExpertTel: item.ApplyExpertTel,
    ApplyId: item.ApplyId,
    ApplyName: item.ApplyName,
    ApplyPerson: item.ApplyPerson,
    ApplyProvince: item.ApplyProvince,
    ApplyProvinceId: item.ApplyProvinceId,
    ApplyRegion: item.ApplyRegion,
    ApplyTel: item.ApplyTel,
  }));
  return axios.post(publicFn.getUrl("Apply_Update"), {
    token: {
      sToken: "60666C4259CF9C06E22CCAB86A74F3CB",
      TimeSpan: "1602473240",
    },
    o: {
      ApplyId,
      ApplyName,
      ApplyTel,
      ApplyPerson,
      ApplyProvinceId,
      ApplyProvince,
      ApplyCityId,
      ApplyCity,
      ApplyAddress,
      ApplyVersion,
      ListShop: formatterListShop,
      ApplySource,
      ApplyTerm,
    },
  });
}

//发送验证码接口
function AliSMSSendSms(PhoneNumbers, code) {
  return axios.post(publicFn.getUrl("AliSMS_SendSms"), {
    PhoneNumbers,
    code,
  });
}

//获取申请
function ApplyGet(ApplyId, ApplyTel, IsChannel = true) {
  return axios.post(publicFn.getUrl("Apply_Get"), {
    token: {
      TimeSpan: 1566827733,
      sToken: "768DCAFFF869CD61372790C2738012EC",
    },
    SearchCondition: {
      ApplyId,
      ApplyTel,
      IsShop: true,
      IsUploadFile: true,
      IsChannel
    },
  });
}

//加入购物车
function FrameDetailAddToCart(
  CHPChooseId,
  CHPProductId,
  CHPProductSortGroup,
  CHPAmount,
  CHPPrescriptionData,
  CHPS_OP_ALL_Id,
  CHPLeftRightEyes,
  CHPPrice
) {
  return axios.post(publicFn.getUrl("frameDetail_addToCart"), {
    token: {
      sToken: "E0B1486293C779EEE7CD24AF277703D7",
      TimeSpan: "1574670974",
    },
    o: {
      CHPChooseId,
      CHPProductId,
      CHPAmount,
      CHPS_OP_ALL_Id,
      CHPLeftRightEyes,
      CHPProductSortGroup,
      CHPPrescriptionData,
      CHPPrice,
    },
  });
}

//公司列表接口
function CompanyInfo(CompanyName) {
  return axios.post(publicFn.getUrl("companyInfo"), {
    token: {
      TimeSpan: 1665294506,
      sToken: "9C1C6159732DCCEB2FF34526FEEFDDF1",
    },
    SearchCondition: {
      CompanyName,
    },
  });
}

//添加订单接口
function UserOrderInsert(UOCompanyId, UOPrice, UOrderNo, IsPhone = false) {
  let UOTotalPrice = UOPrice;
  let UORemark = "官网PC端充值";
  if (IsPhone) {
    UORemark = "官网手机端充值";
  }
  return axios.post(publicFn.getUrl("UserOrder_Insert"), {
    token: {
      TimeSpan: 1665294506,
      sToken: "9C1C6159732DCCEB2FF34526FEEFDDF1",
    },
    o: {
      UOCompanyId,
      UOAddUserId: "00000000-0000-0000-0000-000000000000",
      UOrderNo,
      UOPayState: "order",
      UOPrice,
      UOTotalPrice,
      UORemark,
    },
  });
}

// 微信支付接口
function WXPayNativePayGetPayUrl(price, OrderId) {
  return axios.post(publicFn.getUrl("WXPay_NativePay_GetPayUrl"), {
    token: {
      TimeSpan: 1665294506,
      sToken: "9C1C6159732DCCEB2FF34526FEEFDDF1",
    },
    OrderType: "UserOrder",
    PaySource: "gzh",
    productName: "Visumall充值",
    attach: "Visumall充值",
    price,
    OrderId,
  });
}

// JS微信支付订单接口
// KEY：WXPay_JsApiPay
// URL：https://interface2.visumall.com/WXPay.ashx?cmd=JsApiPay
function WXPayJsApiPay(OrderId, price, openid) {
  return axios.post(publicFn.getUrl("WXPay_JsApiPay"), {
    token: {
      TimeSpan: 1646447586,
      sToken: "43E2A1D33BB9217D36A7BE0D3ED73727",
    },
    OrderId,
    OrderType: "UserOrder",
    openid,
    price,
    productName: "Visumall充值",
    attach: "Visumall充值",
  });
}

// 4、订单查询接口
function UserOrderGet(UOrderId) {
  return axios.post(publicFn.getUrl("UserOrder_Get"), {
    token: {
      TimeSpan: 1665294506,
      sToken: "9C1C6159732DCCEB2FF34526FEEFDDF1",
    },
    SearchCondition: {
      UOrderId,
      isNeedDetailList: false,
    },
  });
}

// JS微信支付订单接口
// KEY：WXPay_JsApiPay
// URL：https://interface2.visumall.com/WXPay.ashx?cmd=JsApiPay
function Wxh5PayStoreGrade(orderId) {
  console.log("Wxh5PayStoreGrade");
  let url = window.location.href.split("#")[0];
  return axios.post(publicFn.getUrl(`/api/wechat/jssdk?url=` + url), {
    orderId,
  });
}

/**
 * 获取版本列表
 * @param {s} param0 
 * @returns 
 */
function  getVersionList({ Channel_No }) {
  const url = publicFn.getUrl("Channel_Get");
  return axios.post(url, {
    token: {
      TimeSpan: 1665294506,
      sToken: "9C1C6159732DCCEB2FF34526FEEFDDF1",
    },
    SearchCondition: {
      Channel_No: Channel_No,
    },
  });
}

export default {
  ApplyInsert,
  AreaGetListLevel,
  UploadFileUpload,
  UploadFileDeleteById,
  ApplyUpdate,
  ApplyGet,
  AliSMSSendSms,
  PriceSortList,
  FrameDetailAddToCart,
  CompanyInfo,
  UserOrderInsert,
  WXPayNativePayGetPayUrl,
  UserOrderGet,
  Wxh5PayStoreGrade,
  getVersionList
};
